import { render, staticRenderFns } from "./uploadDriverCardDialog.vue?vue&type=template&id=6527f310&scoped=true&"
import script from "./uploadDriverCardDialog.vue?vue&type=script&lang=js&"
export * from "./uploadDriverCardDialog.vue?vue&type=script&lang=js&"
import style0 from "./uploadDriverCardDialog.vue?vue&type=style&index=0&id=6527f310&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527f310",
  null
  
)

export default component.exports